const pt = {
    root: ({ props }: { props: { invalid?: boolean } }) => ({
        class: [
            'inline-flex items-center w-full px-3 h-9 rounded-6',
            'border border-gray-200 bg-white text-sm',
            'transition-colors duration-fast cursor-pointer',
            'focus-within:border-teal focus-within:ring-2 focus-within:ring-teal/20',
            props.invalid && 'border-red'
        ]
    }),
    label: ({ props }: { props: { modelValue?: unknown[] } }) => ({
        class: [
            'flex-1 text-left truncate text-sm',
            !props.modelValue || props.modelValue.length === 0 ? 'text-gray-400' : 'text-gray-900'
        ]
    }),
    dropdown: { class: 'flex-none inline-flex items-center justify-center w-5 h-5 text-gray-400 ml-2' },
    clearIcon: { class: 'flex-none w-4 h-4 text-gray-400 hover:text-gray-700 ml-2 cursor-pointer' },
    overlay: {
        class: 'mt-1 bg-white border border-gray-200 rounded-6 shadow-shm z-dropdown overflow-hidden'
    },
    header: { class: 'p-2 border-b border-gray-200' },
    pcFilterContainer: { class: 'relative block w-full' },
    pcFilter: {
        root: { class: '!pl-8' }
    },
    pcFilterIconContainer: {
        class: 'absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none flex items-center'
    },
    pcFilterIcon: { class: 'w-4 h-4' },
    listContainer: { class: 'max-h-64 overflow-auto' },
    list: { class: 'p-1' },
    option: ({ context }: { context: { selected: boolean; focused: boolean } }) => ({
        class: [
            'px-3 py-2 text-sm rounded-4 cursor-pointer flex items-center gap-2',
            context.selected && 'bg-teal-l text-teal-d font-semibold',
            !context.selected && context.focused && 'bg-gray-50',
            !context.selected && !context.focused && 'text-gray-900 hover:bg-gray-50'
        ]
    }),
    optionCheckIcon: { class: 'w-4 h-4 text-teal' },
    headerCheckbox: { root: { class: 'hidden' } }
}

export default pt
